import { Tooltip, Typography } from 'antd';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ifProp } from 'styled-tools';
import { ClassNameProps } from 'components/ozone-component';
import { Task } from 'data/tasks';

const Container = styled.div`
  display: flex;
  align-items: center;
`;

const TaskName = styled.div<{ size?: SizeType }>`
  margin-left: ${ifProp({ size: 'small' }, 'var(--spacing-03)', 0)};
  cursor: pointer;
  padding: var(--spacing-03) 0;
  max-width: 200px;
`;
const { Paragraph } = Typography;

interface Props extends ClassNameProps {
  name: string;
  task: Task;
  size?: SizeType;
  onClick?: (task: Task) => void;
}

export const ApprovalCell: FC<Props> = (props) => {
  const { className, name, task, size = 'middle', onClick } = props;

  return (
    <Container className={className}>
      <TaskName
        size={size}
        onClick={() => onClick && onClick(task)}
        title={name}
      >
        <Tooltip title={name}>
          <Paragraph ellipsis={{ rows: 1 }}>{name}</Paragraph>
        </Tooltip>
      </TaskName>
    </Container>
  );
};
